<div class="inline-block">
  <span class="old-price">{{getOldPrice()}}</span>
  <img alt="" *ngIf="getPriceIsBest() == 1" class="arrow-icon" src="./assets/images/arrow_yellow.png">
  <img alt="" *ngIf="getPriceIsBest() == 0 && getPriceDropIndicator() == -1" class="arrow-icon" src="./assets/images/arrow_green.png">
  <img alt="" *ngIf="getPriceIsBest() == 0 && getPriceDropIndicator() == 1" class="arrow-icon" src="./assets/images/arrow_red.png">
  <!-- <span class="current-price">{{formatPrice(item[currentPriceKey], item.currency)}}</span> -->
  <span class="current-price" [class.preorder]="item.isPreorder">{{getCurrentPrice()}}</span>
</div>